// assets/terms.js
// FHL GO — Terms of Service page behaviour (i18n + reveal + anchor offset)

(function () {
  console.log("[terms.js] loaded");

  /* ===================== I18N TEXT ===================== */

  const I18N = {
  en: {
    toggleLabel: "EN | ES",

    // Breadcrumb / hero label
    crumbHome: "Home",
    crumbTerms: "Terms of Service",
    title: "Terms of Service",
    intro:
      "These Terms govern your use of FHL GO services, our website and apps.",

    // 🟠 HERO KEYS USED IN THE MARKUP
    termsLabel: "Terms of Service",
    termsTitle: "Terms of Service",
    termsIntro:
      "These Terms govern your use of FHL GO services, our website and apps.",

    // TOC labels
    toc_use: "1. Using FHL GO",
    toc_accounts: "2. Accounts & Security",
    toc_shipping: "3. Shipping & Customs",
    toc_pricing: "4. Pricing & Payments",
    toc_prohibited: "5. Prohibited Uses & Items",
    toc_liability: "6. Liability & Limits",
    toc_disputes: "7. Dispute Resolution",
    toc_changes: "8. Changes to these Terms",
    toc_contact: "9. Contact",

    // Body copy
    ctLead: "Questions? Email",

    use_p1:
      "FHL GO provides shipping and related logistics tools. You agree to provide accurate information and comply with all applicable laws while using our services.",
    use_p2:
      "We may update or discontinue features to maintain reliability, security, and legal compliance.",

    acc_p1:
      "You are responsible for safeguarding your credentials and all activity under your account. Notify us immediately of any unauthorized access.",
    acc_p2:
      "We may require identity verification to protect customers and the platform.",

    ship_p1:
      "Shipments are subject to customs, duties, and local regulations. You authorize FHL GO and partners to act as your agent for export, import, and clearance.",
    ship_p2:
      "We operate from Miami with established lanes to Peru, Venezuela, and Costa Rica. Transit times are estimates and can vary due to customs or carrier events.",

    price_p1:
      "Quotes reflect service level, destination, and package attributes. Additional fees (duties, address corrections, storage) may apply where disclosed.",
    pricingNote: "<strong>Prices are estimates and subject to change.</strong>",
    price_p2:
      "By submitting payment, you authorize charges for selected services and approved adjustments.",

    prob_p1:
      "Do not use the site for unlawful purposes or to violate others’ rights. Prohibited items include hazardous materials and counterfeit goods; restricted items may require documentation.",
    prob_p2:
      "We may inspect, refuse, return, or dispose of prohibited items per law and carrier policy.",

    lia_p1:
      "Our liability is limited to the lesser of declared value, replacement value, or applicable carrier limits unless additional coverage is purchased.",
    lia_p2:
      "We are not liable for delays, customs holds, acts of government, or events outside our reasonable control.",

    disp_p1:
      "Contact support first. Where permitted by law, disputes will be resolved by binding arbitration on an individual basis.",

    chg_p1:
      "We may update these Terms to reflect operational or legal changes. Material updates will be posted with an effective date.",

    followTitle: "FOLLOW US ON",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL INFO",
      lnkAbout: "About Us",
      lnkServices: "Services",
      lnkBlog: "Blog",
      lnkTerms: "Terms of Service",
      lnkPrivacy: "Privacy Policy",
      lnkRefunds: "Refund Policy",
      copyright:
        "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",
  },

  es: {
    toggleLabel: "ES | EN",

    crumbHome: "Inicio",
    crumbTerms:"Términos del Servicio",
    title: "Términos del Servicio",
    intro:
      "Estos Términos rigen el uso de los servicios de FHL GO, nuestro sitio web y nuestras aplicaciones.",

    // 🟠 HERO KEYS USED IN THE MARKUP
    termsLabel: "Términos del Servicio",
    termsTitle: "Términos del Servicio",
    termsIntro:
      "Estos Términos rigen el uso de los servicios de FHL GO, nuestro sitio web y nuestras aplicaciones.",

    // TOC labels
    toc_use: "1. Uso de FHL GO",
    toc_accounts: "2. Cuentas y seguridad",
    toc_shipping: "3. Envíos y aduanas",
    toc_pricing: "4. Precios y pagos",
    toc_prohibited: "5. Usos y artículos prohibidos",
    toc_liability: "6. Responsabilidad y límites",
    toc_disputes: "7. Resolución de disputas",
    toc_changes: "8. Cambios a estos términos",
    toc_contact: "9. Contacto",

    ctLead: "¿Dudas? Escribe a",

    use_p1:
      "FHL GO ofrece herramientas de envío y logística relacionada. Aceptas proporcionar información precisa y cumplir con todas las leyes aplicables al usar nuestros servicios.",
    use_p2:
      "Podemos actualizar o descontinuar funciones para mantener la confiabilidad, la seguridad y el cumplimiento legal.",

    acc_p1:
      "Eres responsable de resguardar tus credenciales y toda actividad en tu cuenta. Avísanos de inmediato ante cualquier acceso no autorizado.",
    acc_p2:
      "Podemos requerir verificación de identidad para proteger a los clientes y a la plataforma.",

    ship_p1:
      "Los envíos están sujetos a aduanas, aranceles y regulaciones locales. Autorizas a FHL GO y a sus socios a actuar como tu agente para exportación, importación y despacho.",
    ship_p2:
      "Operamos desde Miami con rutas establecidas a Perú, Venezuela y Costa Rica. Los tiempos de tránsito son estimados y pueden variar por aduanas o eventos del transportista.",

    price_p1:
      "Las cotizaciones reflejan el nivel de servicio, el destino y los atributos del paquete. Pueden aplicarse cargos adicionales (aranceles, correcciones de dirección, almacenaje) cuando se indiquen.",
    pricingNote:
      "<strong>Los precios son estimados y están sujetos a cambios.</strong>",
    price_p2:
      "Al realizar el pago, autorizas los cargos por los servicios seleccionados y los ajustes aprobados.",

    prob_p1:
      "No uses el sitio con fines ilegales ni para violar derechos de terceros. Los artículos prohibidos incluyen materiales peligrosos y mercancía falsificada; los restringidos pueden requerir documentación.",
    prob_p2:
      "Podemos inspeccionar, rechazar, devolver o disponer de artículos prohibidos conforme a la ley y a la política del transportista.",

    lia_p1:
      "Nuestra responsabilidad se limita al menor entre el valor declarado, el valor de reposición o los límites aplicables del transportista, salvo que compres cobertura adicional.",
    lia_p2:
      "No somos responsables por demoras, retenciones aduaneras, actos gubernamentales o eventos fuera de nuestro control razonable.",

    disp_p1:
      "Contacta primero a soporte. Donde la ley lo permita, las disputas se resolverán por arbitraje vinculante de manera individual.",

    chg_p1:
      "Podemos actualizar estos Términos para reflejar cambios operativos o legales. Las actualizaciones materiales se publicarán con su fecha de vigencia.",
    
    followTitle: "SÍGUENOS",
    companyTitle: "COMPAÑÍA",
    legalTitle: "INFO LEGAL",
    lnkAbout: "Quiénes somos",
    lnkServices: "Servicios",
    lnkBlog: "Blog",
    lnkTerms: "Términos del servicio",
    lnkPrivacy: "Política de privacidad",
    lnkRefunds: "Política de reembolsos",
    copyright: "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",
  
    },
};


  function applyLang(lang) {
    const dict = I18N[lang] || I18N.en;
    console.log("[terms.js] applyLang:", lang);

    // Plain text
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.dataset.i18n;
      if (!key) return;
      if (dict[key] !== undefined) el.textContent = dict[key];
    });

    // HTML-enabled (for pricing note)
    document.querySelectorAll("[data-i18n-html]").forEach((el) => {
      const key = el.dataset.i18nHtml;
      if (!key) return;
      if (dict[key] !== undefined) el.innerHTML = dict[key];
    });

    // Update pill label (same “spray and pray” selector set as services.js)
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle && dict.toggleLabel) toggle.textContent = dict.toggleLabel;

    // Document title
    document.title =
      lang === "es"
        ? "FHL GO — Términos del servicio"
        : "FHL GO — Terms of Service";

    // Persist using the SAME key as services.js
    try {
      localStorage.setItem("fhl_lang", lang);
    } catch (e) {}

    // Notify anyone else (logo, other scripts)
    try {
      const ev = new CustomEvent("fhlgo:lang-switch", { detail: { lang } });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("[terms.js] DOMContentLoaded");

    // Initial language (from localStorage, same key as services.js)
    const saved = (() => {
      try {
        return localStorage.getItem("fhl_lang") || "en";
      } catch (e) {
        return "en";
      }
    })();
    applyLang(saved);

    // Find the toggle button (same selector combo as services.js)
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle) {
      console.log("[terms.js] toggle found →", toggle);
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        let current = "en";
        try {
          current = localStorage.getItem("fhl_lang") || "en";
        } catch (err) {}
        const next = current === "en" ? "es" : "en";
        console.log("[terms.js] toggle click →", next);
        applyLang(next);
      });
    } else {
      console.warn("[terms.js] No language toggle found on this page");
    }

    // Also respond if some other script fires fhlgo:lang-switch
    document.addEventListener("fhlgo:lang-switch", function (e) {
      const lang = (e && e.detail && e.detail.lang) || "en";
      console.log("[terms.js] external fhlgo:lang-switch →", lang);
      applyLang(lang);
    });

    // Optional: reveal-on-scroll scoped to terms page (mirroring services pattern)
    if (
      !(
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      )
    ) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const ent of entries) {
            if (ent.isIntersecting) {
              ent.target.classList.add("is-visible");
              io.unobserve(ent.target);
            }
          }
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );

      const nodes =
        document.querySelectorAll(".terms-page [data-reveal]") ||
        document.querySelectorAll("[data-reveal]");

      nodes.forEach((el) => io.observe(el));
    }

    // Anchor offset under sticky header (same idea as services.js)
    const header =
      document.querySelector(".fhlgo-country-header") ||
      document.querySelector(".site-header");
    const setOffset = () => {
      const h = header ? header.offsetHeight : 96;
      document.documentElement.style.setProperty(
        "--anchor-offset",
        h + 12 + "px"
      );
    };
    setOffset();
    window.addEventListener("resize", setOffset);
    window.addEventListener("load", setOffset);
  });
})();
